export var NETWORK_CONNECTION_MESSAGE = "Cannot connect to server, Please try again.";
export var NETWORK_TIMEOUT_MESSAGE = "A network timeout has occurred, Please try again.";
export var UPLOAD_PHOTO_FAIL_MESSAGE = "An error has occurred. The photo was unable to upload.";
export var TIMEOUT_NETWORK = "ECONNABORTED"; // request service timeout
export var NOT_CONNECT_NETWORK_CODE = 500;
